import React, { useState } from "react"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"

import { navigate } from "gatsby"

import "./monitor.scss"

const Monitor = (props) => {
  const [open, setOpen] = useState(false)

  const handleClickOpen = (e) => {
    setOpen(true)
  }

  const handleClose = (e) => {
    setOpen(false)
    navigate(`${props.uri}#${props.index}`)
  }

  return (
    <div className="monitor-wrapper" id={props.index}>
      <div className="monitor-image">
        <div
          onClick={() => {
            handleClickOpen()
          }}
        >
          <img src={props.content.thumbnail} alt="monitor-thumbnail" />
          <div id="play-button"></div>
        </div>

        <Dialog
          className={`device-dialog dialogWrapper`}
          open={open}
          onClose={() => handleClose()}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent className="dialog">
            <div
              className="video_iframe"
              dangerouslySetInnerHTML={{ __html: props.content.iframe }}
            ></div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}

export default Monitor
